import { useEffect, useRef } from 'react';
export const useConcatAsyncEffect = (callback, deps) => {
    const defer = useRef(Promise.resolve(true));
    const f = () => {
        const p = defer.current;
        defer.current = new Promise((resolve) => {
            p.then(() => {
                callback().then(() => resolve(true));
            });
        });
    };
    useEffect(f, deps);
};
